import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { a as g, i as x, d as u, j as S, k as v, l as C, m as k, n as y } from "../../vendor-Dd6qj6gJ.js";
import { c as o } from "../../styles.module-C5RaAp_v.js";
import { ColorFields as N } from "./ColorFields.js";
import { ColorThumb as i } from "./ColorThumb.js";
import { ColorSwatchPicker as P } from "./ColorSwatchPicker.js";
import { Dialog as s } from "../Dialog/index.js";
import { BaseIcon as F } from "../BaseIcon/index.js";
import { getButtonStyles as T } from "../BaseButton/index.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as j } from "../../utils/omitStyleRenderProps/index.js";
function J({
  defaultValue: t = "#FF0000",
  icon: n = "circle-filled",
  buttonSize: m = "md",
  iconSize: f = "lg",
  colorSwatchPalette: b,
  onChangeEnd: a,
  ...r
}) {
  const d = r.value !== void 0, [c, $] = g(r.value, t, r.onChange), h = (typeof c == "string" ? x(c) : c).toFormat("rgb").toString("hex"), p = u(T({ size: m, variant: "ghost" }), o.button);
  return /* @__PURE__ */ l(s.Trigger, { children: [
    /* @__PURE__ */ e(S, { "aria-label": "Open color picker", className: p, style: { color: h }, children: /* @__PURE__ */ e(F, { size: f, icon: n }) }),
    /* @__PURE__ */ e(s.Popover, { children: /* @__PURE__ */ e("div", { className: o.colorPicker, children: /* @__PURE__ */ l(
      v,
      {
        ...j(r),
        ...d ? { value: r.value } : { defaultValue: t },
        onChange: $,
        children: [
          /* @__PURE__ */ e(
            C,
            {
              className: o.colorArea,
              colorSpace: "hsb",
              xChannel: "saturation",
              yChannel: "brightness",
              onChangeEnd: a,
              children: /* @__PURE__ */ e(i, {})
            }
          ),
          /* @__PURE__ */ e(
            k,
            {
              channel: "hue",
              colorSpace: "hsb",
              className: o.colorSlider,
              onChangeEnd: a,
              children: /* @__PURE__ */ e(y, { className: o.colorSliderTrack, children: /* @__PURE__ */ e(i, {}) })
            }
          ),
          /* @__PURE__ */ e(N, {}),
          /* @__PURE__ */ e(P, { palette: b })
        ]
      }
    ) }) })
  ] });
}
export {
  J as ColorPicker
};
